module.exports = __webpack_public_path__ + "img/Number=14.055cc6a2.png";